import type { FluidSharedTree } from "../fluid/fluid.client.js";
import {
  getTableIdFromUser,
  isUserInAreaWithoutVoiceCall,
} from "../fluid/fluid.service.js";

export const getParticipantIds = (participants: Iterable<string>) =>
  new Set([...participants].filter(Boolean));

export const getNewParticipantIds = ({
  currentParticipantIds,
  ownUserId,
  previousParticipantIds,
}: {
  currentParticipantIds: Set<string>;
  ownUserId: string;
  previousParticipantIds: Set<string>;
}) => {
  const newParticipantIds: string[] = [];

  for (const participantId of currentParticipantIds) {
    if (
      participantId !== ownUserId &&
      !previousParticipantIds.has(participantId)
    ) {
      newParticipantIds.push(participantId);
    }
  }

  return newParticipantIds;
};

export const getLiveCurrentUserTableId = ({
  sharedTree,
  userId,
}: {
  sharedTree: FluidSharedTree;
  userId: string;
}) => {
  if (isUserInAreaWithoutVoiceCall({ sharedTree, userId })) {
    return null;
  }

  return getTableIdFromUser({ sharedTree, userId });
};

export const getCurrentTableParticipantIds = ({
  sharedTree,
  tableId,
  userId,
}: {
  sharedTree: FluidSharedTree;
  tableId: string | null;
  userId: string;
}) => {
  const liveTableId = getLiveCurrentUserTableId({
    sharedTree,
    userId,
  });

  if (!(tableId && liveTableId === tableId)) {
    return null;
  }

  const table = sharedTree.root.tables.find(
    (candidate) => candidate?.id === tableId
  );
  if (!table) {
    return null;
  }

  return getParticipantIds(table.participants);
};
